import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Country, Recipient } from 'app/modules/bulk-pay/_state/bulk-pay.interfaces';
import { AppState, selectCountries, selectCountriesError, selectCountriesLoading, selectTransactionHistory, selectTransactionHistoryError, selectTransactionHistoryLoading } from 'app/reducers';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import * as dashboardActions from '../../dashboard/_state/dashboard.actions'
import * as bulkPayActions from '../_state/bulk-pay.actions'
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-successful-bulk-pay-transactions',
  templateUrl: './successful-bulk-pay-transactions.component.html',
  styleUrls: ['./successful-bulk-pay-transactions.component.css']
})
export class SuccessfulBulkPayTransactionsComponent implements OnInit {

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private toastService: ToastrService,
    private router: Router,
    public miscService: MiscService
  ) { }

  private unsubscribe$ = new Subject<void>();
  isRecipients: boolean;
  selectedRecipients: Recipient[];
  successfulkBulkPayTransactions$ = this.store.pipe(select(selectTransactionHistory))
  successfulkBulkPayTransactionsLoading$ = this.store.pipe(select(selectTransactionHistoryLoading))
  successfulkBulkPayTransactionsError$ = this.store.pipe(select(selectTransactionHistoryError))
  countries$ = this.store.pipe(select(selectCountries))
  countriesLoading$ = this.store.pipe(select(selectCountriesLoading))
  countriesError$ = this.store.pipe(select(selectCountriesError))
  countries
  ngOnInit(): void {
    this.countries$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: Country[]) => this.countries = res);
    this.fetchCountries();
    this.fetchSuccessfulBulkPayTransactions()
  }
  fetchCountries = () =>  this.store.dispatch(bulkPayActions.fetchCountries())
  getCountry = (code) => this.countries?.find(country => code === country.alpha2Code || code === country.alpha3Code)?.currencyCode

  // API CALLS
  fetchSuccessfulBulkPayTransactions = () => {
    this.store.dispatch(dashboardActions.fetchTransactionHistory({txnId: 'bulkpay', status: '0'}))
  }


  // UNSUBCRIBE FROM OBSERVABLES
  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

}
